// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-landing-main[data-v-3231e78c]  a:not(.v-btn):not(.k-nav__link){color:inherit}.k-landing-main__layout[data-v-3231e78c]{height:100%;display:flex;flex-direction:column}.banner[data-v-3231e78c]{margin-top:80px}@media screen and (max-width:959px){.banner[data-v-3231e78c]{margin-top:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
